import { jsx as _jsx } from "react/jsx-runtime";
import { Editor } from '@tinymce/tinymce-react';
import { forwardRef, useMemo } from 'react';
import { fullOptions } from './config/options/full';
export const Component = ({ disabled, init = fullOptions, name, onBlur, onChange, onFocus, onInit, placeholder, tinymceScriptSrc = 'https://static.hvbrt.com/tinymce/6.8.2/tinymce.min.js', value, }, ref) => {
    const safeInit = useMemo(() => (Object.assign(Object.assign({}, init), { convert_unsafe_embeds: true })), [init]);
    return (_jsx(Editor, { disabled: disabled, id: name, init: safeInit, initialValue: placeholder, onBlur: onBlur, onEditorChange: onChange, onFocus: onFocus, onInit: (_, editor) => {
            if (!ref) {
                return;
            }
            if (typeof ref === 'function') {
                ref(editor);
            }
            else {
                ref.current = editor;
            }
            onInit === null || onInit === void 0 ? void 0 : onInit(_, editor);
        }, textareaName: name, tinymceScriptSrc: tinymceScriptSrc, value: value }));
};
export const TinyMceEditorComponent = forwardRef(Component);
//# sourceMappingURL=TinyMceEditorComponent.js.map